import { useRemoteConfigBoolean } from "reactfire";
import { createLogger } from "../../utils/logger";

const logger = createLogger("useFavoritesEnabled");

export const useFavoritesEnabled = () => {
  const { data: favoritesEnabled, status } =
    useRemoteConfigBoolean("favoritesEnabled");

  if (status === "loading") {
    return false;
  }

  if (status === "error") {
    logger.error("Error fetching remote config for favoritesEnabled");
    return false;
  }

  return favoritesEnabled;
};
